export default __webpack_public_path__ + "static/media/instacart.75237c37.svg";